
export function getTranslation(lang, term){
    let trads = {
        'fr' : {
            'diapoNber' : 'Nombre de diapositives',
            'photoNber' : 'Nombre de photos',
            'negatifNber' : 'Nombre de négatifs',
            'filmNber' : 'Nombre de bobines',
            'tapeNber' : 'Nombre de cassettes',
            'diapoSelectItemByItem' : 'par diapo',
            'photoSelectItemByItem' : 'par photo',
            'negatifSelectItemByItem' : 'par négatif',
            'filmSelectItemByItem' : 'par bobine',
            'tapeSelectItemByItem' : 'par cassette'
        }
    }
    let defaultLang = 'fr';
    let lang_ = trads[lang] ? lang : defaultLang;
    return trads[lang_][term] ? trads[lang_][term] : '';
}